module.exports = __webpack_public_path__ + "img/uploader-file.c4b9ed63.svg";